// Description: This file contains the functions that make AJAX calls to the server.

/**
 * Makes an AJAX call to the specified URL with the provided parameters.
 * @param {string} url - The URL to make the AJAX call to.
 * @param {string} str - The additional parameters to append to the URL.
 * @param {boolean} isPageRedirect - Indicates whether the response should redirect the page or log the response.
 */
const callHandler = (url, str, isPageRedirect) => {
    const xmlhttp = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");

    xmlhttp.onreadystatechange = () => {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200 && xmlhttp.responseText !== '') {
            isPageRedirect ? window.location.href = xmlhttp.responseText : console.log(xmlhttp.responseText);
        }
    };

    xmlhttp.open("GET", `${url}${str}`, true);
    xmlhttp.send();
};
